import systemApi from 'api/systemApi'
import Global from 'general/utils/Global'

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

// MARK --- Thunk: ---
export const thunkGetCompanyProfile = createAsyncThunk(
  'system/company',
  async (params, thunkApi) => {
    const res = await systemApi.getCompanyProfile(params)
    return res
  },
)

export const thunkGetProvince = createAsyncThunk(
  'system/province',
  async (params) => {
    const res = await systemApi.getProvince(params)
    return res
  },
)

export const thunkGetTaxAuthority = createAsyncThunk(
  'system/tax-authority',
  async (params) => {
    const res = await systemApi.getTaxAuthorityByProvine(params)
    return res
  },
)

export const thunkUpdateCompanyProfile = createAsyncThunk(
  'system/update-company',
  async (params) => {
    const res = await systemApi.updateCompanyProfile(params)
    return res
  },
)

export const thunkUpdateCompanyType = createAsyncThunk(
  'system/update-company-type',
  async (params) => {
    const res = await systemApi.updateCompanyType(params)
    return res
  },
)

export const thunkGetProvince2025 = createAsyncThunk(
  'system/province-2025',
  async (params) => {
    const res = await systemApi.getProvince2025(params)
    return res
  },
)

export const thunkGetTaxAuthority2025 = createAsyncThunk(
  'system/tax-authority-2025',
  async (params) => {
    const res = await systemApi.getTaxAuthorityByProvine2025(params)
    return res
  },
)

const systemSlice = createSlice({
  name: 'system',
  initialState: {
    pagination: { perPage: Global.gDefaultPagination },

    isGettingCompanyProfile: false,
    company: {},

    provinces: [],

    taxAuthorities: [],
    provinces2025: [],

    taxAuthorities2025: [],
  },
  reducers: {
    setPaginationPerPage: (state, action) => {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          perPage: action.payload,
        },
      }
    },
  },
  extraReducers: (builder) => {
    // company profile
    builder.addCase(thunkGetCompanyProfile.pending, (state, action) => {
      state.isGettingCompanyProfile = true
    })
    builder.addCase(thunkGetCompanyProfile.rejected, (state, action) => {
      state.isGettingCompanyProfile = false
    })
    builder.addCase(thunkGetCompanyProfile.fulfilled, (state, action) => {
      state.isGettingCompanyProfile = false
      const company = action.payload
      if (company) {
        state.company = company
      }
    })

    // province
    builder.addCase(thunkGetProvince.fulfilled, (state, action) => {
      const { provinces } = action.payload
      if (provinces) {
        state.provinces = provinces
      }
    })

    // tax authority
    builder.addCase(thunkGetTaxAuthority.fulfilled, (state, action) => {
      const { taxAuthorities } = action.payload
      if (taxAuthorities) {
        state.taxAuthorities = taxAuthorities
      }
    })

    // province
    builder.addCase(thunkGetProvince2025.fulfilled, (state, action) => {
      const { provinces } = action.payload
      if (provinces) {
        state.provinces2025 = provinces
      }
    })

    // tax authority
    builder.addCase(thunkGetTaxAuthority2025.fulfilled, (state, action) => {
      const { taxAuthorities } = action.payload
      if (taxAuthorities) {
        state.taxAuthorities2025 = taxAuthorities
      }
    })

    // update company profile
    builder.addCase(thunkUpdateCompanyProfile.pending, (state, action) => {
      state.isGettingCompanyProfile = true
    })
    builder.addCase(thunkUpdateCompanyProfile.rejected, (state, action) => {
      state.isGettingCompanyProfile = false
    })
    builder.addCase(thunkUpdateCompanyProfile.fulfilled, (state, action) => {
      state.isGettingCompanyProfile = false
      // const { company, result } = action.payload;
      // if (result === 'success') {
      //   state.company = company;
      // }
    })
  },
})

const { actions, reducer } = systemSlice
export const { setPaginationPerPage } = actions
export default reducer
